import React, { useRef, useState } from "react";
import { RCCBadge, RCCHookToast, RCCServicesApi } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import IComponentBadge from "react-common-components/dist/components/Badge/interface";
import { ActionTraceability } from "../../interface";
import BadgeTraceabilityBasic from "./badgeTraceabilityBasic";

export interface IBadgeTraceabilityCard{
	controllerMethod?: string;
	color?: IComponentBadge["color"];
	textBadge?: string;
	hideBadge?: boolean;
    codTraceability?: number;
    id: number;
}

const BadgeTraceabilityCard: React.FC<IBadgeTraceabilityCard> = ({
	controllerMethod = "Actions",
	color = "grey",
	textBadge,
	hideBadge = false,
	id,
	codTraceability
}) => {
	if(hideBadge)
		return null;

	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
    
	const [traceability, setTraceability] = useState();
	const timer = useRef<number>(0);

	const onMouseOverBadge = () => {
		timer.current = window.setTimeout(() => {
			getTraceability();
		}, 500);
	};

	const onMouseOutBadge = () => {
		window.clearTimeout(timer.current);
	};

	const getTraceability = async () => {
		try{
			const result = await RCCServicesApi.getRequest({
				method: `${controllerMethod}/GetTraceability`,
				urlParameters: {id}
			});

			setTraceability(result.data);
		}catch(err){
			standardErrorMessages(err, translate("Erro ao buscar a rastreabilidade"), addToast);
		}
	};

	const getTraceabilityMessage = () => {
		if(textBadge)
			return textBadge;
		
		let traceabilityMessage = "";
		if(codTraceability){
			switch(codTraceability.toString()){
			case ActionTraceability.INICIATIVE_MAP:
				traceabilityMessage =`${translate("Iniciativa")} - ${translate("Mapa")}`;
				break;
			case ActionTraceability.FCA_INDICATOR:
				traceabilityMessage = `${translate("FCA")} - ${translate("Indicador")}`;
				break;
			case ActionTraceability.MEETING:
				traceabilityMessage =`${translate("Reunião")}`;
				break;
			case ActionTraceability.PROJECT:
				traceabilityMessage =`${translate("Projeto")}`;
				break;
			case ActionTraceability.RISK:
				traceabilityMessage =`${translate("Risco")}`;
				break;	
			case ActionTraceability.OCCURRENCE:
				traceabilityMessage =`${translate("Ocorrência")}`;
				break;	
			case ActionTraceability.INICIATIVE_OKR:
				traceabilityMessage =`${translate("Iniciativa")} - ${translate("OKR")}`;
				break;
			default:
				traceabilityMessage = "";
				break;
			}
		}

		return traceabilityMessage;
	};

	

	return(
		<>
			{
				traceability ? 
					<BadgeTraceabilityBasic 
						color={color}
						layout="card"
						textBadge={getTraceabilityMessage()}
						traceability={traceability}
					/>

					: 

					<>
						{getTraceabilityMessage() !== "" && (
							<div onMouseOverCapture={onMouseOverBadge} onMouseOutCapture={onMouseOutBadge}>
								<RCCBadge color={color} styleInline="padding: 2px 8px; font-size: 0.78rem;" >
									{getTraceabilityMessage()}
								</RCCBadge>
							</div>
						)}
					</>
			}
		</>
	);
};

export default BadgeTraceabilityCard;
